// extracted by mini-css-extract-plugin
export var externalLinksWrapper = "IndexPage-module--externalLinksWrapper--37P-z";
export var homePage = "IndexPage-module--homePage--WjhtA";
export var internalLinksWrapper = "IndexPage-module--internalLinksWrapper--o-xtx";